import React, { useState, useEffect, useRef } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { generateOtp,validateOtp } from '../api/api'; // Adjust path if needed
import '../assets/styles/SignInPage.css'; // Your styles

const SignInForm = () => {
  const [mobileNumber, setMobileNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [isValidPhone, setIsValidPhone] = useState(true);
  const [showSendOtpButton, setShowSendOtpButton] = useState(true);
  const resendTimerRef = useRef(null);

  const validatePhoneNumber = (number) => {
    const phoneRegex = /^[0-9]{10}$/;
    return phoneRegex.test(number);
  };

const handleSendOtp = async () => {
  if (!validatePhoneNumber(mobileNumber)) {
    setIsValidPhone(false);
    return;
  }
  setIsValidPhone(true);

  // Clear old OTP value
  setOtp('');

  setShowSendOtpButton(false);
  setOtpSent(true);

  try {
    const otpReceived = await generateOtp({
      mobileNumber,
      otpType: "Registration",
      deviceId: "web",
      ipAddress: "192.192.192.192",
    });
    console.log("Test OTP (for development):", otpReceived);

    resendTimerRef.current = setTimeout(() => {
      if (otp.trim().length === 0) {
        setShowSendOtpButton(true);
        setOtpSent(false);
      }
    }, 30000);
  } catch (error) {
    console.error("Failed to send OTP:", error);
    alert("Unable to send OTP. Please try again.");
    setShowSendOtpButton(true);
    setOtpSent(false);
  }
};

const handleSignIn = async () => {
  try {
    const result = await validateOtp({ mobileNumber, otpCode: otp });
    if (result.is_verified) {
      console.log('OTP Verified for user:', result.user_id);
      // Proceed to sign-in success flow
    } else {
      alert('OTP verification failed: ' + result.message);
    }
  } catch (error) {
    alert('Something went wrong during OTP validation');
  }
};
 

  useEffect(() => {
    if (otp.length > 0) {
      setShowSendOtpButton(false);
      if (resendTimerRef.current) {
        clearTimeout(resendTimerRef.current);
      }
    }
  }, [otp]);

  useEffect(() => {
    return () => {
      if (resendTimerRef.current) {
        clearTimeout(resendTimerRef.current);
      }
    };
  }, []);
  useEffect(() => {
  if (otpSent) {
    setOtpSent(false);
    setOtp('');
    setShowSendOtpButton(true);
  }
}, [mobileNumber]);


  return (
    <Form>
      <h2>Sign In</h2>

      <Form.Group controlId="mobileNumber">
        <Form.Label>Mobile Number</Form.Label>
        <InputGroup>
          <InputGroup.Text id="basic-addon1">
            <i className="bi bi-telephone-fill"></i>
          </InputGroup.Text>
          <Form.Control
            type="text"
            placeholder="Enter mobile number"
            value={mobileNumber}
            onChange={(e) => setMobileNumber(e.target.value)}
            isInvalid={!isValidPhone}
          />
          <Form.Control.Feedback type="invalid">
            Please enter a valid 10-digit mobile number.
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>

      {otpSent && (
        <Form.Group controlId="otp" className="mt-3">
          <Form.Label>Enter OTP</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter 6-digit OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
        </Form.Group>
      )}

      {showSendOtpButton ? (
        <Button variant="primary" onClick={handleSendOtp} className="mt-3">
          Send OTP
        </Button>
      ) : (
        <Button variant="primary" onClick={handleSignIn} className="mt-3">
          Sign In
        </Button>
      )}

      <p className="mt-3">
        Not registered? <Link to="/join">Click here to join</Link>
      </p>
    </Form>
  );
};

export default SignInForm;
